import { render, staticRenderFns } from "./bulma_picturesmanager.vue?vue&type=template&id=55831c7e"
import script from "./bulma_picturesmanager.vue?vue&type=script&lang=js"
export * from "./bulma_picturesmanager.vue?vue&type=script&lang=js"
import style0 from "./bulma_picturesmanager.vue?vue&type=style&index=0&id=55831c7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports